import * as Mutation from './mutation-types'

export default {
  [Mutation.SET_TERMO_BUSCA_GERAL_PLATAFORMA] (state, termoBuscaGeralPlataforma) {
    state.termoBuscaGeralPlataforma = termoBuscaGeralPlataforma
  }
}
